import React, { Component } from 'react';
import GeneralComments from '../../../../GeneralComponents/ChatBoxModuleComment';
import RkHeader from '../../../../GeneralComponents/RkHeader';
import IndexTaskModule from '../../../tasks/taskBoard/IndexTaskModule';

class Show extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            activeTab: 'tablero',
            users: [],
        };
    }

    componentDidMount = () => {
        const array = (this.props.users || []).map(item => ({ label: item.name, value: item.id }));
        this.setState({ users: array });
    }

    render() {
        const { cause } = this.props;
        const board = cause.task_board;

        return (
            <React.Fragment>
                <RkHeader
                    title={`Causa: ${cause.cause}`}
                    subtitle={"Gestión de riesgos"}
                    icon="fas fa-toolbox"
                    showNew={false}
                    showFilter={false}
                />

                <nav aria-label="breadcrumb" className="rk-wrap">
                    <div className="rk-breadcrumb">
                        <a href={`/failure/efects`} data-turbolinks="true">
                            <i className="fas fa-cogs"></i> AMEF
                        </a>
                        <span className="rk-breadcrumb__sep">/</span>
                        <span className="rk-breadcrumb__current">{`Causa: ${cause.cause}`}</span>
                    </div>
                </nav>

                <div className="rk-wrap">
                    {/* Info del fallo / NPR */}
                    <div className="rk-info">
                        <div className="rk-scores">
                            <div className="rk-score">
                                <div className="rk-score__label">Ocurrencia</div>
                                <span className="rk-score__badge">{cause.ocurrency_score_first}</span>
                            </div>
                            <div className="rk-score">
                                <div className="rk-score__label">Detectabilidad</div>
                                <span className="rk-score__badge">{cause.detectability_score_first}</span>
                            </div>
                            <div className="rk-score rk-score--total">
                                <div className="rk-score__label">NPR</div>
                                <span className="rk-score__badge rk-score__badge--lg">{cause.npr_score_first}</span>
                            </div>
                        </div>

                        <div className="rk-info-grid rk-info-grid--bottom">
                            <div className="rk-info-field">
                                <div className="rk-info-field__label">Control</div>
                                <div className="rk-info-field__value">{cause.control}</div>
                            </div>
                            <div className="rk-info-field">
                                <div className="rk-info-field__label">Fallo</div>
                                <div className="rk-chips">
                                    <span className="rk-chip">Modo: {cause.failure.mode}</span>
                                    <span className="rk-chip">Efecto: {cause.failure.effect}</span>
                                </div>
                            </div>
                            <div className="rk-info-field">
                                <div className="rk-info-field__label">Actividad</div>
                                <div className="rk-chips">
                                    <span className="rk-chip">{cause.activity.name}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tabs: Tablero / Comentarios */}
                    <div className="rk-tabs">
                        <button
                            className={`rk-tabs__btn ${this.state.activeTab === 'tablero' ? 'is-active' : ''}`}
                            onClick={() => this.setState({ activeTab: 'tablero' })}
                        >
                            <i className="fas fa-columns"></i> Tablero
                        </button>
                        <button
                            className={`rk-tabs__btn ${this.state.activeTab === 'comentarios' ? 'is-active' : ''}`}
                            onClick={() => this.setState({ activeTab: 'comentarios' })}
                        >
                            <i className="far fa-comments"></i> Comentarios
                        </button>
                    </div>

                    {/* Tab Tablero (Kanban) */}
                    {this.state.activeTab === 'tablero' && (
                        board ? (
                            <IndexTaskModule
                                task_board={board}
                                user={this.props.user}
                                users={this.props.users}
                                estados={this.props.estados}
                                procesos={this.props.procesos}
                                columns={this.props.columns}
                                labels={this.props.labels}
                                tasks={this.props.tasks}
                                task_sources={this.props.task_sources}
                                company={this.props.company}
                                imageUpload={this.props.imageUpload}
                                key_text={this.props.key_text}
                            />
                        ) : (
                            <div className="rk-panel-empty">
                                <i className="fas fa-columns"></i>
                                <p>Preparando el tablero…</p>
                            </div>
                        )
                    )}

                    {/* Tab Comentarios */}
                    {this.state.activeTab === 'comentarios' && (
                        <div className="rk-panel">
                            <div className="rk-panel__body" style={{ padding: 0 }}>
                                <GeneralComments
                                    usuario={this.props.user}
                                    module_name={"Causas de riesgos"}
                                    users={this.state.users}
                                    module_comment={cause.module_comment_id}
                                    url={this.props.url}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default Show;
